"use client";

import React from "react";
import type {
  CollaboratorsOnLists,
  FollowersOnLists,
  List,
  GoogleImage,
  PlaceAffiliate,
  Place,
  Spot,
  SpotImage,
  Trip,
  TripDay,
  TripItem,
  User,
  UserSpotFav,
  UserSpotVisit,
} from "@prisma/client";
import { PageWithNavBar } from "@/components/v3/PageWithNavBar";
import { GuidesViewContent } from "./GuidesViewContent";

export const GuidesView = ({
  list,
  currentUser,
}: {
  list: List & {
    user: User;
    spots: (Spot & {
      images: SpotImage[];
      place: Place & { googleImages: GoogleImage[]; affiliates: PlaceAffiliate[] };
      list: List & { user: User; spots: Spot[] };
      user: User;
    })[];
  };
  currentUser:
    | (User & {
        lists: (List & { spots: Spot[] })[];
        followingLists: FollowersOnLists[];
        collaboratingLists: CollaboratorsOnLists[];
        favedSpots: UserSpotFav[];
        visitedSpots: UserSpotVisit[];
        trips: (Trip & {
          tripDays: (TripDay & {
            items: (TripItem & {
              spot: Spot | null;
            })[];
          })[];
        })[];
      })
    | null;
}): JSX.Element => {
  return (
    <>
      <PageWithNavBar className="hidden md:flex">
        <GuidesViewContent list={list} currentUser={currentUser} />
      </PageWithNavBar>

      <GuidesViewContent list={list} currentUser={currentUser} className="block md:hidden" />
    </>
  );
};
